import type {Surface} from '../surface';
import {handoffUrl, handOffTo} from './handoff';

export const identityLoginUrl = (
  origins: Partial<Record<Surface, string>> | undefined,
  next?: string
): string | undefined => {
  const path = next ? `/?next=${encodeURIComponent(next)}` : '/';
  return handoffUrl(origins, 'identity', path);
};

export const redirectToIdentityLogin = (
  origins: Partial<Record<Surface, string>> | undefined,
  next?: string
): void => {
  const url = identityLoginUrl(origins, next);
  if (url) {
    handOffTo(url);
  }
};
